/* @flow strict */

/* eslint-disable camelcase */

import * as React from 'react';
import _ from 'lodash';
import moment from 'moment';
import Modal from '/client/src/components/Modal';
import Switcher from '/client/src/components/switcher';
import SimpleSelect from '/client/src/components/forms/select';
import SimpleInput from '/client/src/components/forms/simpleInput';
import TagsInput from 'react-tagsinput';
import Loader from '/client/src/components/Loader';
import DateTimePickerSplitted from '/client/src/components/dateTimePicker/dateTimePickerSplitted';
import BtnLoader from '/client/src/components/btns/circularProgress/';
import { POST, PUT, GET } from '/client/src/api';
import { timeerOffModal } from '/client/src/constants/';
import { EventDetailContainerContext } from '/client/src/contexts/EventDetailContainer';
import DiscountValidator from './modalDataValidation';
import { getValidTickets } from './index';
import { convertToLocalTime, convertToUTC } from '/client/src/utils/jstz';
import { currency } from '/client/src/constants/';

import './styles.scss';

type PropsType = {
  isOpen: boolean,
  handleShowModal: (boolean) => void,
  handleAddDiscount: () => void,
  isOpenModalFor: null | string,
  selectedRow?: {
    group_id: number,
    codes: []
  },
  discounts: [],
  eventId: number | string,
  defaultContainerContext: {
    handleShowSystemDialog: () => void
  }
};

class EventPageDetailDiscountCodesModal extends React.Component<PropsType> {
  props: PropsType;

  static contextType = EventDetailContainerContext;

  constructor(props: PropsType, context: {}) {
    super(props, context);

    this.state = {
      isLoaded: false,
      selectedCodes: _.get(props.selectedRow, 'codes', []),
      limitNumberOn: false,
      limitNumber: 0,
      limitCheckout: 0,
      limitCheckoutOn: false,
      avaliableWindowOn: false,
      selectedDVType: currency[_.get(props, 'defaultContainerContext.profileCurrent.currency')],
      selectedRow: props.selectedRow,
      tickets: [],
      amount: '',
      percentage: '',
      use_percentage: false,
      isLocked: false,
      applied_to_all_tickets: false,
      applied_to_ticket_id: [],
      sponsors: [],
      sponsorId: null,
      sponsorsIsLoaded: props.isOpenModalFor === 'Edit',
      isShowSponsors: false,
      applied_to_ticket_temp_id: [],
      contextPriceTickets: [],
      isValidCode: true
    };

    this.buttonRef = React.createRef();
  }

  componentDidMount = async () => {
    const { isOpenModalFor, eventId } = this.props;

    this.setState({ contextPriceTickets: getValidTickets(this.context.eventDetail.tickets) });

    setTimeout(() => {
      // $('.dropdown-tickets button').on('click', function () {
      //   $(this).parent().toggleClass('open');
      // });

      // eslint-disable-next-line
      $('body').on('click', function (e: any) {
        if (!$('.dropdown-tickets').is(e.target)
          && $('.dropdown-tickets').has(e.target).length === 0
          && $('.open').has(e.target).length === 0
        ) {
          $('.dropdown-tickets').removeClass('open');
        }
      });
    }, 1000);

    if (isOpenModalFor !== 'Edit') {
      const { result } = await GET(`/api/v1/1/sponsors/byevent/${eventId}`);

      this.setState({
        sponsors: _.map(result, (r: {}): {} => {
          // HACK (invalid response from API)
          return {
            ...r,
            label: r.name,
            value: r.id
          };
        }),
        sponsorsIsLoaded: true
      });
    }
  }

  handleClose = (): any => {
    const { handleShowModal } = this.props;

    handleShowModal(false);
  };

  handleChangeCheckbox = (e: any, status: boolean) => {
    const name = e.target.name;

    this.setState({
      [name]: status
    });
  };

  hadleChangeDVType = (value: string) => {
    this.setState({
      selectedDVType: value,
      use_percentage: value === '%'
    });
  };

  handleLoaded = async (error: Error, response: any) => {
    if (!error) {
      const { result: { discounts, tickets, sponsors } } = response.data;
      const isEdit = this.props.isOpenModalFor === 'Edit';

      let appliedTickets = [];

      if (discounts[0].applied_to_all_tickets) {
        appliedTickets = _.map(isEdit ? tickets : this.state.contextPriceTickets, (t: {}): number => t.id);
      } else {
        appliedTickets = isEdit ? discounts[0].applied_to_ticket_id : [];
      }
      this.setState({
        isLoaded: true,
        ids: _.map(discounts, (d: {}): {} => ({ id: d.id, code: d.coupon_code })),
        group_id: discounts[0].group_id,
        applied_to_ticket_temp_id: appliedTickets,
        applied_to_ticket_id: appliedTickets,
        applied_to_all_tickets: discounts[0].applied_to_all_tickets,
        limitNumberOn: discounts[0].is_enable_limitation_times,
        limitNumber: discounts[0].limitation_times,
        limitCheckoutOn: discounts[0].is_enable_usage_per_checkout,
        limitCheckout: discounts[0].usage_per_checkout,
        avaliableWindowOn: discounts[0].is_enable_expiration,
        beginTimeUTC: discounts[0].begin_time_utc && convertToLocalTime(`${discounts[0].begin_time_utc}Z`, this.context.eventDetail.time_zone_id),
        endTimeUTC: discounts[0].end_time_utc && convertToLocalTime(`${discounts[0].end_time_utc}Z`, this.context.eventDetail.time_zone_id),
        selectedDVType: discounts[0].use_percentage ? '%' : currency[_.get(this.props, 'defaultContainerContext.profileCurrent.currency')], // TODO
        tickets,
        amount: discounts[0].amount / 100,
        percentage: discounts[0].percentage,
        use_percentage: discounts[0].use_percentage,
        sponsorId: discounts[0].sponsor_id || null,
        isShowSponsors: discounts[0].sponsor_id,
        sponsors: _.map(sponsors, (s: {}): {} => {
          return {
            ...s,
            value: s.id,
            label: s.name
          };
        })
      });
    }
  }

  handleChange = (codes: []) => {
    const _codes = _.filter(codes, (i: string): boolean => i.trim() !== '');
    const caseInsensitiveUniqueCodes = _codes.map(s => s.toLowerCase()).reduce((map, s, i) =>
      map.get(s) ? map : map.set(s, _codes[i]), new Map());

    if (_.size(_codes) < 10) {
      this.setState({
        selectedCodes: [...caseInsensitiveUniqueCodes.values()],
        isValidCode: true
      });
    }
  };

  handleChangeInput = (e: any) => {
    const { name, value } = e.target;

    this.setState({
      [name]: value
    });
  }

  handleSelectAllTickets = () => {
    const {
      tickets
    } = this.state;

    const data = _.map(
      this.props.isOpenModalFor === 'Edit' ? tickets : this.state.contextPriceTickets,
      (t: {}): number => t.id);

    this.setState({
      applied_to_all_tickets: true,
      applied_to_ticket_id: data,
      applied_to_ticket_temp_id: data
    });
  }

  setApliedTicketsTickets = (data: [], isEdit: boolean) => {
    // HACK incorrect data from API
    const _tickets = isEdit ? this.state.tickets : this.state.contextPriceTickets;

    this.setState({
      applied_to_ticket_id: data,
      applied_to_ticket_temp_id: data,
      applied_to_all_tickets: _.size(data) === _.size(_tickets)
    });
  }

  getTicketsNameArr = (data: []): [] => {
    const isEdit = this.props.isOpenModalFor === 'Edit';

    const _tickets = isEdit ? this.state.tickets : this.state.contextPriceTickets;

    return _.map(data, (tid: {}): string => {
      const _ticket = _.find(_tickets, (_t: {}): {} => _t.id === tid);

      return _.get(_ticket, 'name', '');
    });
  }
  defaultPasteSplit(data) {
    return data.split(/[\n\r\s\,]+/).map(d => d.trim());
  }

  content = (): React.Element<'div'> => {
    const {
      tickets,
      limitNumber,
      limitNumberOn,
      limitCheckoutOn,
      limitCheckout,
      avaliableWindowOn,
      beginTimeUTC,
      endTimeUTC,
      selectedDVType,
      amount,
      // applied_to_all_tickets,
      applied_to_ticket_temp_id,
      applied_to_ticket_id,
      isShowSponsors,
      sponsors,
      sponsorId,
      sponsorsIsLoaded,
      isValidCode
    } = this.state;

    const isEdit = this.props.isOpenModalFor === 'Edit';
    const att = isEdit ? applied_to_ticket_id : applied_to_ticket_temp_id;

    return (
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12" style={{ marginBottom: '1.5rem', zIndex: 9 }}>

            <label htmlFor="">Discount codes</label>
            <TagsInput
              value={this.state.selectedCodes}
              onChange={this.handleChange}
              inputProps={{
                placeholder: ''
              }}
              addKeys={[9, 13, 32, 188]}
              addOnPaste
              addOnBlur
              pasteSplit={this.defaultPasteSplit}
              onlyUnique
              validationRegex={/^[A-z0-9-+.]{0,70}$/}
              onValidationReject={(): void => this.setState({ isValidCode: false })}
            />

            {!isValidCode &&
              <span className='EventPageDiscountModal-overlimit'>
                Discount name has a 70 characters limit and must not contain special characters (e.g. “!#$%#$^*")
              </span>
            }
          </div>

          <div className="col-md-6">
            <label>Applies to</label>
            <div className="dropdown dropdown-tickets">
              <button
                className="btn btn-default dropdown-toggle"
                style={{ width: '100%' }}
                type="button"
                aria-haspopup="true"
                aria-expanded="false"
                onClick={() => {
                  $('.dropdown-tickets').toggleClass('open');
                }}
              >
                <div style={{ cursor: 'pointer' }}>
                  <span>
                    {_.size(att) === _.size(isEdit ?
                      tickets : this.state.contextPriceTickets) ?
                      <>All Tickets</> :
                      <>{
                        _.size(att) === 1 ?
                          <>{_.map(isEdit ?
                            tickets : this.state.contextPriceTickets, (t: {}): string => {
                              if (t.id.toString() === (att)[0].toString()) {
                                return t.name;
                              }
                            })}</> :
                          <>
                            {_.size(att) === 0 ?
                              <></> :
                              <>{_.size(this.state.applied_to_ticket_id)} tickets</>
                            }
                          </>
                      }</>
                    }
                  </span>
                  <span className="caret-right">
                    <span className="caret" />
                  </span>
                </div>
              </button>
              <ul className="dropdown-menu" role="menu" style={{ width: '100%' }}>
                <li onClick={this.handleSelectAllTickets}>
                  <a
                    style={{
                      cursor: 'pointer',
                      padding: '6px 20px'
                    }}
                  >All Tickets</a>
                </li>
                <li role="separator" className="divider" />
                { // HACK tickets : this.state.contextPriceTickets -> incorrect response from API
                  _.map(isEdit ?
                    tickets : this.state.contextPriceTickets, (t: {}, ti: number): React.Element<'li'> => {
                      const appliedTickets = isEdit ? applied_to_ticket_id : applied_to_ticket_temp_id;

                      return (
                        <li key={`${t.id}-${ti}`}>
                          <a title={t.name}>
                            <label className="icheckbox" style={{ margin: '6px 0' }}>
                              <input
                                checked={_.indexOf(appliedTickets, t.id) !== -1}
                                type="checkbox"
                                id={t.id}
                                onChange={(e: any) => {
                                  const isChecked = e.target.checked;

                                  let arr;

                                  if (isChecked) {
                                    arr = [...appliedTickets, t.id];
                                  } else {
                                    // arr = _.map(appliedTickets, (_t: string): string => {
                                    //   if (_t.toString() !== +t.id.toString()) {
                                    //     return t.id.toString();
                                    //   }
                                    // });

                                    arr = _.remove(appliedTickets, (n: string): string => {
                                      return n.toString() !== t.id.toString();
                                    });
                                  }

                                  this.setApliedTicketsTickets(_.compact(arr), isEdit);
                                }}
                              />
                              <i className="icheckbox-icon" />
                              <span data-bind="text:name">{t.name}</span>
                            </label>
                          </a>
                        </li>
                      );
                    })}
              </ul>
            </div>

          </div>
          <div className="col-md-6">
            <label htmlFor='Discount_values'>Discount values</label>
            <div className="input-group form-group SimpleInput">
              <div className="input-group-btn">
                <button
                  type="button"
                  className="btn btn-default dropdown-toggle"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  style={{
                    borderColor: 'transparent',
                    background: '#eeeeee',
                    width: '56px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                  }}
                >
                  <span>{selectedDVType}</span>
                  <span className="caret" />
                </button>
                <ul className="dropdown-menu Discount_values_drop">
                  <li
                    onClick={() => {
                      this.hadleChangeDVType('%');

                      if (amount > 100) {
                        this.setState({ amount: 100 });
                      }
                    }}
                  ><span>%</span></li>
                  <li
                    onClick={() => {
                      this.hadleChangeDVType(currency[_.get(this.props, 'defaultContainerContext.profileCurrent.currency')]);
                    }}
                  >
                    {/* // TODO */}
                    <span>{currency[_.get(this.props, 'defaultContainerContext.profileCurrent.currency')]}</span>
                  </li>
                </ul>
              </div>
              <input
                id='Discount_values'
                type="number"
                className="form-control"
                name='amount'
                value={amount}
                onChange={(e: any) => {
                  if ((this.state.selectedDVType === '%' && e.target.value > 100) || e.target.value < 0) return;
                  this.handleChangeInput(e);
                }}
              />
            </div>
          </div>
        </div>

        <br />
        <br />

        <div className="row">
          <div className="col-md-6">
            <Switcher
              className='form-switcher-sm pull-left mb1rem'
              id='limit'
              index='limit'
              name='limitNumberOn'
              checked={limitNumberOn}
              onCallback={this.handleChangeCheckbox}
              label='Limit each code to a specific number of uses'
            />
            {!!limitNumberOn &&
              <SimpleInput
                name='Usage_limit'
                id='Usage_limit'
                label='Usage limit'
                type='number'
                style={{ paddingLeft: '3rem' }}
                value={limitNumber}
                onChange={(e: any) => {
                  this.handleChangeInput({
                    target: {
                      name: 'limitNumber',
                      value: e.target.value
                    }
                  });
                }}
              />
            }

          </div>

          <div className="col-md-6">
            <Switcher
              className='form-switcher-sm pull-left mb1rem'
              id='limit2'
              index='limit2'
              name='limitCheckoutOn'
              checked={limitCheckoutOn}
              onCallback={this.handleChangeCheckbox}
              label='Limit each code usage per checkout'
            />

            {!!limitCheckoutOn &&
              <SimpleInput
                name='Usage_per_checkout'
                id='Usage_per_checkout'
                label='Usage per checkout'
                type='number'
                style={{ paddingLeft: '3rem' }}
                value={limitCheckout}
                onChange={(e: any) => {
                  this.handleChangeInput({
                    target: {
                      name: 'limitCheckout',
                      value: e.target.value
                    }
                  });
                }}
              />
            }
          </div>
        </div>

        <br />

        <div className="row">
          <div className="col-md-6">
            <Switcher
              className='form-switcher-sm pull-left mb1rem'
              id='availability'
              index='availability'
              name='avaliableWindowOn'
              checked={avaliableWindowOn}
              onCallback={this.handleChangeCheckbox}
              label='Discount Code Start and End Time'
            />
          </div>
        </div>

        {!!avaliableWindowOn &&
          <div className='form-group SimpleInput discount-dates'>
            <div>
            <div style={{ marginBottom: '5px' }}>Start Date</div>
              <div className="input-group date">
                <DateTimePickerSplitted
                  date={beginTimeUTC}
                  cb={(date: string) => {
                    this.handleChangeInput({
                      target: {
                        name: 'beginTimeUTC',
                        value: date
                      }
                    });
                  }}
                />
              </div>
            </div>

            <div>
            <div style={{ marginBottom: '5px' }}>End Date</div>
              <div className="input-group date">
                <DateTimePickerSplitted
                  date={endTimeUTC}
                  cb={(date: string) => {
                    this.handleChangeInput({
                      target: {
                        name: 'endTimeUTC',
                        value: date
                      }
                    });
                  }}
                />
              </div>
            </div>
          </div>
        }

        <br />

        <div className="row">
          <div className="col-md-6">
            {sponsorsIsLoaded ?
              <Switcher
                className='form-switcher-sm pull-left mb1rem'
                id='isShowSponsors'
                index='isShowSponsors'
                name='isShowSponsors'
                checked={!!_.size(isShowSponsors)}
                onCallback={(e: any, newStatus: boolean) => {
                  this.setState({
                    sponsorId: !newStatus ? null : _.get(sponsors, '[0].id', null)
                  });

                  this.handleChangeCheckbox(e, newStatus);
                }}
                label='Attach to Sponsor'
              /> :
              <div>
                <span style={{ paddingRight: '3rem' }}>Loading sponsors...</span>
                <span className="csspinner" />
              </div>
            }
          </div>
        </div>

        {(sponsorsIsLoaded && isShowSponsors) &&
          <div className='row'>
            <div className="col-md-6">
              <SimpleSelect
                label='Sponsor'
                items={sponsors}
                style={{ paddingLeft: '3rem' }}
                value={sponsorId}
                callBack={(e: any) => {
                  this.setState({
                    sponsorId: e.target.value
                  });
                }}
              />
            </div>
          </div>
        }
      </div>
    );
  }

  handleSaveCodes = async (setStatus: (string) => void, isOpenModalFor: string): any => {
    const isEdit = isOpenModalFor === 'Edit';

    const {
      isLocked,
      ids,
      selectedCodes,
      amount,
      // percentage,
      // use_percentage,
      applied_to_all_tickets,
      applied_to_ticket_id,
      applied_to_ticket_temp_id,
      group_id,
      limitNumberOn,
      limitNumber,
      limitCheckoutOn,
      limitCheckout,
      selectedDVType,
      avaliableWindowOn,
      beginTimeUTC,
      endTimeUTC,
      sponsorId
    } = this.state;

    const {
      eventId,
      discounts,
      selectedRow,
      defaultContainerContext
    } = this.props;

    if (isLocked || !eventId) {
      return false;
    }


    const ErrorCallback = (action: string, error: any, additionalMsg: string = '') => {
      defaultContainerContext.handleShowSystemDialog(true, {
        systemDialogType: 'error',
        systemDialogTitle: 'Error!',
        systemDialogContent: `Can't ${action} codes ${additionalMsg}`
      });

      setStatus('error');
      if (error) {
        console.error(error);
      }

      setTimeout(() => {
        setStatus('');
      }, timeerOffModal * 2);
    };

    let errorMsg = '';
    const selectedCodesLowerCase = selectedCodes.map(x => x.toLowerCase());
    const selectedGroupId = selectedRow ? selectedRow.group_id : -1;
    const otherDiscounts = isEdit ? discounts.filter(x => x.group_id !== selectedGroupId) : discounts;

    otherDiscounts.forEach(discount =>
      discount.codes.forEach(code => {
        if (selectedCodesLowerCase.includes(code.toLowerCase())) {
          errorMsg = (<>
            Can not save code. Discount codes can not be repeated. Make sure the following is used only once:
            <li>{code}</li>
          </>);
        }
      })
    );
    if (errorMsg) {
      defaultContainerContext.handleShowSystemDialog(true, {
        systemDialogType: 'error',
        systemDialogTitle: 'Error!',
        systemDialogCallback: () => {
          defaultContainerContext.handleShowSystemDialog(false);
        },
        systemDialogCallbackActions: ['Ok'],
        systemDialogContent: (errorMsg)
      });
      setStatus('error');

      setTimeout(() => {
        setStatus('');
      }, timeerOffModal * 2);
      return false;
    }

    const groupId = (_.max(_.map(discounts, (d: {}): number => d.group_id)) || 0) + 1;
    const bTime = beginTimeUTC ? convertToUTC(beginTimeUTC, this.context.eventDetail.time_zone_id) : moment().utc().format();
    const sTime = endTimeUTC ? convertToUTC(endTimeUTC, this.context.eventDetail.time_zone_id) : moment().utc().format();
    const _applied_to_tickets = this.getTicketsNameArr(isEdit ? applied_to_ticket_id : applied_to_ticket_temp_id);

    const _row = {
      'amount': amount * 100,
      applied_to_all_tickets,
      applied_to_ticket_id,
      applied_to_ticket_temp_id,
      'applied_to_tickets': _applied_to_tickets,
      'group_id': isEdit ? group_id : groupId,
      'is_reveal_ticket': false,
      'is_enable_limitation_times': limitNumberOn,
      'limitation_times': limitNumber,
      'is_disabled': false,
      'percentage': selectedDVType === '%' ? amount : 0,
      'use_percentage': selectedDVType === '%',
      'is_enable_usage_per_checkout': limitCheckoutOn,
      'usage_per_checkout': limitCheckout,
      'is_enable_expiration': avaliableWindowOn,
      'end_time_utc': sTime,
      'begin_time_utc': bTime,
      'sponsor_id': sponsorId
    };

    const data = {
      group_id: isEdit ? group_id : groupId,
      'discounts': _.map(selectedCodes, (d: string, i: number): {} => {
        return {
          ..._row,
          'coupon_code': d,
          'id': isEdit ? _.get(
            _.find(
              ids,
              (item: string): {} => item.code === d),
            'id', -1000 - group_id - i) : -1000 - groupId - i
          // 'id': -1000 - (isEdit ? group_id : groupId)
        };
      })
    };

    const isValid = DiscountValidator({
      _applied_to_tickets,
      applied_to_all_tickets,
      codes: selectedCodes,
      discounts: amount,
      usageLimitOn: limitNumberOn,
      usageLimit: limitNumber,
      perCheckoutLimitOn: limitCheckoutOn,
      perCheckoutLimit: limitCheckout,
      expiredStartOn: avaliableWindowOn,
      expiredEndOn: avaliableWindowOn,
      expiredStart: bTime,
      expiredEnd: sTime
    }, defaultContainerContext.handleShowSystemDialog);

    if (_.size(isValid)) {
      defaultContainerContext.handleShowSystemDialog(true, {
        systemDialogType: 'warning',
        systemDialogTitle: 'Hmmm...',
        systemDialogCallback: () => {
          defaultContainerContext.handleShowSystemDialog(false);
        },
        systemDialogCallbackActions: ['Ok'],
        systemDialogContent: (<>
          You must select at least one:
          <ul
            style={{
              listStyleType: 'circle',
              listStylePosition: 'inside',
              marginTop: '1rem',
              marginLeft: '1rem',
              fontSize: '1rem'
            }}
          >
            {_.map(isValid, (f: string, fi: number): string => {
              return (
                <li key={`DiscountValidator-${fi}`}>
                  {f === 'appliedToTickets' && 'Ticket'}
                  {f === 'codeValidation' && 'Discount codes'}
                  {f === 'discountValue' && 'Discount values'}
                  {f === 'usageLimit' && 'Usage limit'}
                  {f === 'perCheckoutLimit' && 'Usage per checkout'}
                  {f === 'perCheckoutLimit' && 'Usage per checkout'}
                </li>
              );
            })}
          </ul>
        </>)
      });

      return false;
    }

    this.setState({
      isLocked: true
    }, () => {
      setStatus('loading');
    });

    if (!isEdit) {
      try {
        const { result, success } = await POST(`/api/v1/1/discounts/${this.props.eventId}/add`, data);

        if (success) {
          this.setState({
            isLocked: false
          }, () => {
            if (!_.size(result.discounts)) {
              setStatus('error');

              this.setState({
                isLocked: false
              });
              ErrorCallback('create');
            } else {
              setStatus('success');

              defaultContainerContext.handleShowSystemDialog(true, {
                systemDialogType: 'success',
                systemDialogTitle: 'Great!',
                systemDialogContent: 'Discount was added'
              });
              const discountsWithTicketNames = result.discounts.map((el: any): any =>
              ({
                ...el,
                applied_to_ticket_id: this.getTicketsNameArr(el.applied_to_ticket_id)
              }));

              this.props.handleAddDiscount(discountsWithTicketNames, !isEdit ? 'add' : 'update');
            }

            this.handleClose();
          });
        }
      } catch (error) {
        this.setState({
          isLocked: false
        }, () => {
          ErrorCallback('create', error);
        });
      }
    } else {
      try {
        const { success } = await PUT(`/api/v1/1/discounts/${this.props.eventId}/update`, data);

        if (success) {
          this.setState({
            isLocked: false
          }, () => {
            setStatus('success');

            defaultContainerContext.handleShowSystemDialog(true, {
              systemDialogType: 'success',
              systemDialogTitle: 'Great!',
              systemDialogContent: 'Discount was updated'
            });

            const discountsWithTicketNames = data.discounts.map((el: any): any =>
            ({
              ...el,
              applied_to_ticket_id: this.getTicketsNameArr(el.applied_to_ticket_id)
            }));

            this.props.handleAddDiscount(discountsWithTicketNames, !isEdit ? 'add' : 'update');

            this.handleClose();
          });
        }
      } catch (error) {
        this.setState({
          isLocked: false
        }, () => {
          ErrorCallback('update', error);
        });
      }
    }
    this.context.handleUpdateData();
  };

  render(): React.Element<'div'> {
    const { isOpen, isOpenModalFor, eventId, selectedRow } = this.props;

    return (
      <Modal
        overflow='visible'
        opened={isOpen}
        onClose={this.handleClose}
        altView
        isScrollable
      >
        <div className={`
            modal-dialog
            customModal
            EventPageDetailCustomersModal
            EventPageDiscountModal
            modal-table-filter
          `} role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">
                <span>{isOpenModalFor} discount codes</span>
              </h4>
            </div>
            <div className="modal-body" style={{ padding: '2rem 0 1rem', minHeight: '100px' }}>

              {isOpenModalFor === 'Create' ?
                <>{this.content()}</> :
                <>
                  <Loader
                    url={`/api/v1/1/discounts/${eventId}/${selectedRow.group_id}`}
                    onLoaded={this.handleLoaded}
                  >
                    {this.state.isLoaded && <>{this.content()}</>}
                  </Loader>
                </>
              }

            </div>
            <div className="modal-footer">
              <button className="btn btn-gray" onClick={this.handleClose}>Cancel</button>
              <span className='custom-pb-container'>
                <BtnLoader
                  label={'Save'}
                  handleCallBack={(e: SyntheticEvent<HTMLButtonElement>, setStatus: (string) => void) => {
                    this.handleSaveCodes(setStatus, isOpenModalFor);
                  }}
                />
              </span>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

export default EventPageDetailDiscountCodesModal;
